export default {"src":"/_next/static/image/public/images/ic_big_no_members.f2684d41d3dc63b86c8bf2b4c4f0edcf.svg","height":139,"width":171};